import { useLocation } from 'react-router-dom';
import { carePortalPages } from '../pages';

type AppLocation = 'admin-dashboard' | 'avon-patient' | 'care-portal';

export const useAppLocation = (): AppLocation => {
  const location = useLocation();
  const pathname = location.pathname;

  if (pathname.includes('admin-dashboard')) {
    return 'admin-dashboard';
  }

  if (pathname.includes('avon-patient')) {
    return 'avon-patient';
  }

  if (
    pathname === '/' ||
    carePortalPages.some(page => pathname.includes(page))
  ) {
    return 'care-portal';
  }

  throw new Error('Unknown app location');
};
